import React from "react";
import "./Page2.css";
import img1 from "../../assets/imgp2.png";
import img2 from "../../assets/imgp21.jpg";

const Page2 = () => {
  return (
    <div className="page2-main">
      <div className="page21-main">
        <div className="page21 imgi1">
          <img src={img1} alt="" />
          <h3 style={{paddingTop:"15px"}}>Internship</h3>
          <p>
            Career Phoenix - The World's Biggest cum Training Program. An ideal
            and best platform for young people to grow and succed
          </p>
          <button className="butn">Explore More</button>
        </div>
        <div className="page21 imgi2">
          <img src={img2} alt="" />
          <h3>Research and Development</h3>
          <p>
            R&D develpes new technologies. It's where we innovate, process and
            imporove product. We work on different things using trending
            technologies
          </p>
          <button className="butn">Explore More</button>
        </div>
      </div>
    </div>
  );
};

export default Page2;
